export const Tooltip = {
  baseStyle: {
    bg: 'black',
    '--popper-arrow-bg': 'black',
  },
};
